function sanitizeNumericInput(rawValue) {
  return String(rawValue || '').replace(/\D+/g, '');
}

function toSafeInteger(rawValue, fallback = 0) {
  const sanitized = sanitizeNumericInput(rawValue);
  if (!sanitized) {
    return fallback;
  }

  const parsed = Number.parseInt(sanitized, 10);
  if (!Number.isFinite(parsed)) {
    return fallback;
  }

  return parsed;
}

export function getQuestionFiveSuggestedHours(serviceDuration) {
  const numeric = Number(serviceDuration);
  if (!Number.isFinite(numeric) || numeric < 0) {
    return '00:00';
  }

  const totalMinutes = Math.round(numeric * 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

export function normalizeQuestionFiveHourPart(rawValue) {
  return String(Math.max(0, toSafeInteger(rawValue, 0)));
}

export function normalizeQuestionFiveMinutePart(rawValue) {
  const safeMinute = Math.max(0, Math.min(59, toSafeInteger(rawValue, 0)));
  return String(safeMinute).padStart(2, '0');
}

export function buildQuestionFiveHoursValue(hoursPart, minutesPart) {
  const normalizedHours = normalizeQuestionFiveHourPart(hoursPart);
  const normalizedMinutes = normalizeQuestionFiveMinutePart(minutesPart);
  return `${String(normalizedHours).padStart(2, '0')}:${normalizedMinutes}`;
}

export function shouldShowQuestionFiveSyncNotice({
  isManuallyEdited = false,
  manualReference = '',
  suggestedHours = '',
} = {}) {
  if (!isManuallyEdited) {
    return false;
  }

  const normalizedReference = String(manualReference || '').trim();
  const normalizedSuggested = String(suggestedHours || '').trim();
  if (!normalizedReference || !normalizedSuggested) {
    return false;
  }

  return normalizedReference !== normalizedSuggested;
}